import React from "react";

export default function SearchInput({
  value,
  onChange,
  placeholder = "Search...",
}) {
  return (
    <div className="max-w-6xl mx-auto px-4 md:px-0 py-4">
      <div className="relative">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full h-10 px-4 rounded-full bg-[var(--bg)] border border-[var(--bg-lighter)] outline-none focus:border-[var(--primary-muted)]
            text-[var(--foreground-muted)] text-sm font-sans font-medium placeholder:text-[var(--foreground-muted)] transition-colors duration-300 ease-in-out" />

        {value && (
          <button
            onClick={() => onChange("")}
            className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full w-6 h-6
             text-sm text-[var(--primary)] hover:text-[var(--background)] bg-[var(--primary-muted)] hover:bg-[var(--primary)]  transition-colors duration-300 ease-in-out">
            ✕
          </button>
        )}
      </div>
    </div>
  );
}